<template>
    <div class="vue_flex vue_column">
        <div class="cont_wrapper">
            <div class="cont_wrapper_sx">
                <div class="shaixuan_left">
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con" style="margin-right: 10px">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt="" />
                            <div class="shaixuan_item_tit">统计时间</div>
                        </div>
                        <el-date-picker v-model="listQuery.time" type="datetimerange" range-separator=""
                            start-placeholder="" end-placeholder="" value-format="timestamp" class="vue_flex_item"
                            style="border: none">
                        </el-date-picker>

                    </div>
                    <div class="shaixuan_item h">
                        <div class="shaixuan_item_con">
                            <img class="shaixuan_item_icon" src="../../../../../assets/ym/qd@2x.png" alt="" />
                            <div class="shaixuan_item_tit">商品</div>
                        </div>
                        <el-select v-model="listQuery.goodsid" placeholder="请选择" class="vue_flex_item">
                            <el-option v-for="item in goodsOptions" :key="item.goodsid" :label="item.goodsname"
                                :value="item.goodsid"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="shaixuan_btns">
                    <div class="shaixuan_btn1 h" @click="qingchu">清除</div>
                    <div class="shaixuan_btn2 h" @click="kemufeiyongFun">查询</div>
                </div>
            </div>

            <div class="manage-boxs vue_flex vue_column">
                <div class="vue_flex vue_align_center">
                    <p class="vue-font-PingFang-bold font20 line_height_20">渠道</p>
                    <span v-for="(channel, channelIndex) in channelList" :key="channelIndex"
                        :class="channelIn === channelIndex ? 'active' : 'activenot'"
                        @click="eventClick('channel', channel, channelIndex)">{{ channel.title }}</span>
                </div>
                <div class="vue_flex vue_align_center">
                    <p class="vue-font-PingFang-bold font20 line_height_20">店铺</p>
                    <span v-for="(shop, shopIndex) in dpList" :key="shopIndex"
                        :class="shopIn === shopIndex ? 'active' : 'activenot'"
                        @click="eventClick('shop', shop, shopIndex)">{{ shop.name }}</span>
                </div>
                <div class="vue_flex vue_align_center">
                    <p class="vue-font-PingFang-bold font20 line_height_20">一级科目</p>
                    <span v-for="(subjectone, subjectoneIndex) in subjectoneList" :key="subjectoneIndex"
                        :class="subjectoneIn === subjectoneIndex ? 'active' : 'activenot'"
                        @click="eventClick('subjectone', subjectone, subjectoneIndex)">{{ subjectone.title }}</span>
                </div>
                <div class="vue_flex vue_align_center">
                    <p class="vue-font-PingFang-bold font20 line_height_20">二级科目</p>
                    <span v-for="(subjecttwo, subjecttwoIndex) in subjecttwoList" :key="subjecttwoIndex"
                        :class="subjecttwoIn === subjecttwoIndex ? 'active' : 'activenot'"
                        @click="eventClick('subjecttwo', subjecttwo, subjecttwoIndex)">{{ subjecttwo.title }}</span>
                </div>
                <!-- <div class="vue_flex vue_align_center">
          <p class="vue-font-PingFang-bold font20 line_height_20">选择汇总</p>
          <span
            v-for="(pool, poolIndex) in poolList"
            :key="poolIndex"
            :class="poolIn === poolIndex ? 'active' : 'activenot'"
            @click="eventClick('pool', pool, poolIndex)"
            >{{ pool.title }}</span
          >
        </div> -->
                <div class="vue_flex vue_align_center"></div>
            </div>

            <template>
                <el-table :data="tableData" style="width: 100%"
                    :header-cell-style="{ backgroundColor: '#f5f7fa', color: '#333' }" key="costtable">
                    <el-table-column prop="riqi" label="日期" align="center"></el-table-column>
                    <el-table-column prop="yiji" label="一级科目" align="center"></el-table-column>
                    <el-table-column prop="erji" label="二级科目" align="center"></el-table-column>
                    <el-table-column prop="feiyong" label="费用额" align="center"></el-table-column>
                    <el-table-column prop="koudian" label="扣点" align="center"></el-table-column>
                    <el-table-column prop="feilv" label="费比" align="center"></el-table-column>
                </el-table>
            </template>

            <!-- <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="kemufeiyongFun"
      /> -->
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import * as echarts from "echarts";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import linkwhole from "@/components/linkwhole/index";

export default {
    components: { Pagination, linkwhole },
    data() {
        return {
            total: 0,
            listQuery: {
                page: 1,
                limit: 1000,
                time: [],
                goodsid: '',
            },
            channelIn: 0,
            channelList: [{ title: "淘宝" }, { title: "京东" }, { title: "拼多多" }],
            shopIn: 0,
            shopList: [
                { title: "A店铺" },
                { title: "C店铺" },
                { title: "C店铺" },
                { title: "D店铺" },
            ],
            subjectoneIn: 0,
            subjectoneList: [{ title: "平台费⽤" }],
            subjecttwoIn: 0,
            subjecttwoList: [
                { title: "4001平台佣⾦扣点", type: 'yongjin', },
                { title: "4002平台活动扣点", type: 'huodong', },
                { title: "4003平台其他费⽤", type: 'qita', },
            ],
            poolIn: 0,
            poolList: [
                { title: "管理费用" },
                { title: "店铺" },
                { title: "商品ID" },
                { title: "商品SKU" },
            ],

            userObj: {},
            tableData: [],

            goodsOptions: [],

            value1: "",
            dpList: [],
        };
    },
    async mounted() {
        await this.getdpListFun();
        await this.getgoodslistFun()
        await this.kemufeiyongFun()
    },

    methods: {
        qingchu() {
            this.listQuery = {
                page: 1,
                limit: 10,
                time: [],
                goodsid: '',
            };
            this.kemufeiyongFun();
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },

        async getgoodslistFun() {
            const res = await this.$http.get(this.$urls.getgoodslist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.goodsOptions = res.list;
        },

        async kemufeiyongFun() {
            console.log('this.listQuery--->', {
                starttime: this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime: this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
                ...this.listQuery,
                type: Number(this.channelIn) + 1,
                erji: this.subjecttwoList[this.subjecttwoIn].type,
            });
            const res = await this.$http.post(this.$urls.kemufeiyong, {
                starttime: this.listQuery.time.length > 0 ? this.listQuery.time[0] / 1000 : "",
                endtime: this.listQuery.time.length > 0 ? this.listQuery.time[1] / 1000 : "",
                ...this.listQuery,
                type: Number(this.channelIn) + 1,
                erji: this.subjecttwoList[this.subjecttwoIn].type,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            console.log('reslist--', res.list);
            this.tableData = res.list

        },

        getHetongListFun() { },

        eventClick(type, row, index) {
            if (type === "channel") {
                if (this.channelIn === index) return;
                this.channelIn = index;
            }
            if (type === "shop") {
                if (this.shopIn === index) return;
                this.shopIn = index;
            }
            if (type === "subjectone") {
                if (this.subjectoneIn === index) return;
                this.subjectoneIn = index;
            }
            if (type === "subjecttwo") {
                if (this.subjecttwoIn === index) return;
                this.subjecttwoIn = index;
            }
            if (type === "pool") {
                if (this.poolIn === index) return;
                this.poolIn = index;
            }
            this.kemufeiyongFun()
        },
    },
};
</script>

<style lang="scss" scoped>
#myChart {
    width: 1508px;
    height: 300px;
    background: #f5f5f5;
}

.manage-boxs {
    div {
        margin-top: 21px;

        p {
            width: 100px;
            padding-right: 20px;
            text-align: right;
        }

        span {
            min-width: 106px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            border-radius: 10px;
            margin-right: 14px;
            padding: 0px 27px;
            display: block;
            cursor: pointer;
        }
    }

    .active {
        background: rgba(25, 92, 248, 1);
        color: rgba(255, 255, 255, 1);
    }

    .activenot {
        background: rgba(245, 245, 245, 1);
        color: rgba(35, 35, 35, 1);
    }
}

.shaixuan_btns {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    .shaixuan_btn1 {
        width: 132px;
        height: 55px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #999999;
        text-align: center;
        line-height: 55px;
    }

    .shaixuan_btn2 {
        margin-left: 25px;
        width: 131px;
        height: 54px;
        background: #195cf8;
        border-radius: 10px;
        text-align: center;
        line-height: 55px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
    }
}

.cont_wrapper {
    padding: 25px;

    .cont_wrapper_sx {
        width: 1527px;
        height: 71px;
        background: #f5f5f5;
        border-radius: 10px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .shaixuan_left {
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
        }

        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;

                .shaixuan_item_tit {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #232323;
                }

                .shaixuan_item_sel {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 18px;
                    color: #999999;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }
}

.shaixuan_item {
    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/costmanage/terrace/index.vue